//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NavigationButton from './NewNavigationButton.vue';
import ExternalLinkIcon from '~/assets/svg/ic-external-link.svg?inline';
import ExternalLinkIconHovered from '~/assets/svg/ic-external-link-hovered.svg?inline';

export default {
  components: {
    NavigationButton,
    ExternalLinkIcon,
    ExternalLinkIconHovered,
  },
  props: {
    activeIndex: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isBr() {
      return this.$nuxt.$config.COUNTRY === 'br';
    },
  },
};
